import React, { useEffect, useState } from 'react';
import { Layout, Menu, Card, Input } from 'antd';
import Button from 'components/Button';
import PasswordInput from 'components/PasswordInput';
import Logo from 'components/Logo';
import AuthService from 'services/AuthService';
import HTTPClient from 'services/HTTPClient';
import { useNavigate } from "react-router-dom";
import ErrorIndicator from 'components/ErrorIndicator';
import { getErrorMessage } from 'utils';

const { Header, Content } = Layout;
const LOGIN_ENDPOINT = "/api/auth/local"

const LoginPage: React.FC = () => {

    const [password, setPassword] = useState("")
    const [username, setUsername] = useState("")
    const [error, setError] = useState(null)
    const [isSigningIn, setIsSigningIn] = useState(false)
    let navigate = useNavigate();

    useEffect(() => {
        if (AuthService.isLoggedIn()) {
            navigate("/profiles")
        }
    }, [navigate])


    const performSignIn = async (event) => {
        event.preventDefault()

        setIsSigningIn(true)
        setError(null)
        try {
            let data = {
                identifier: username,
                password,
            }
            let response = await HTTPClient.get().postDataWithoutAuthForJSONResult(LOGIN_ENDPOINT, data)
            console.log(response)
            await AuthService.setToken(response.jwt)
            setIsSigningIn(false)
            setError(null)
            navigate("/profiles")
        } catch (error: any) {
            console.log(getErrorMessage(error))
            setError(getErrorMessage(error))
            setIsSigningIn(false)
        }
    }

    return (
        <Layout className='h-100'>
            <Header
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <Logo />
                <Menu
                    theme="dark"
                    mode="horizontal"
                >
                </Menu>
            </Header>
            <Content className='d-flex justify-content-center align-items-start' style={{ padding: '0 50px', height: "100%" }}>
                <Card className='login-card' title="Login" bordered={false}>
                    <form onSubmit={performSignIn}>
                        <Input className='mt-6' placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} />
                        <PasswordInput className='mt-5' value={password} onChange={e => setPassword(e.target.value)} />
                        <Button type='submit' isLoading={isSigningIn} className='w-100 mt-5' >Login</Button>
                    </form>
                    {error && <ErrorIndicator error={error} />}
                    <div className='my-6' style={{ height: "40px", lineHeight: "40px", textAlign: "center" }}>
                        Don't have an account? <button type="button" className={"btn no-bg "} onClick={() => { }}>Get the app</button>
                    </div>
                </Card>
            </Content>
        </Layout>
    );
};

export default LoginPage;